export const minimumJournalPages = 1
export const maximumJournalPages = 8
export const journalPageOptions = Array.from(
  { length: maximumJournalPages - minimumJournalPages + 1 },
  (_, index) => minimumJournalPages + index,
)

export function normalizeJournalPages(value: unknown) {
  const parsed = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(parsed)) return minimumJournalPages
  return Math.min(maximumJournalPages, Math.max(minimumJournalPages, Math.round(parsed)))
}

export function canEditJournalPages(canManageSubtasks: boolean, createdBy: string, currentUser: string) {
  return canManageSubtasks || createdBy === currentUser
}
